import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store/index'
import Language from './modules/Language'
import UserInfo from './modules/UserInfo'
import Axios from 'axios'
import Notifications from 'vue-notification'
import VueSimpleAlert from "vue-simple-alert";

let language = new Language();
Axios.defaults.baseURL = window.baseURL;

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(Notifications)
Vue.use(VueSimpleAlert);
Vue.use(require('vue-shortkey'), { prevent: ['textarea'] })

new Vue({
  el: '#app',
  router,
  language,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  data() {
    return {
        Language: language,
        UserInfo: new UserInfo(),
    }
  }
})

if (!String.format) {
    String.format = function (format) {
        var args = Array.prototype.slice.call(arguments, 1);
        try {
            return format.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined'
                    ? args[number]
                    : match
                    ;
            });
        }
        catch (ex) {
            return format;
        }
    };
}



// WEBPACK FOOTER //
// ./src/main.js